import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    title: _ctx.helper.trans('labels.invite_url'),
    modelValue: _ctx.visible,
    "body-class": "d-flex",
    "footer-class": "d-flex",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.visible = $event))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "me-2",
        title: _ctx.url,
        style: {"overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"}
      }, [
        _createElementVNode("a", {
          href: _ctx.url,
          target: "_blank"
        }, [
          _createElementVNode("small", null, _toDisplayString(_ctx.url), 1)
        ], 8, _hoisted_2)
      ], 8, _hoisted_1),
      _createVNode(_component_copy_button, { value: _ctx.url }, null, 8, ["value"])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.visible = false)),
        class: "btn btn-outline-primary btn-sm text-capitalize-first"
      }, _toDisplayString(_ctx.helper.trans('button.ok')), 1)
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}